/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import CardComponent from "../components/CardComponent.jsx";

function Startpage() {
    return (
        <div className={"mt-2"}>
            <CardComponent title={"TODOS"} isDefaultOpen={false}>
                <div className={"p-2"}>
                    We have the opportunity to change the URL handling for production so that each customer has
                    their
                    own base subdomain.
                    We also have a check before each deployment to ensure that the domain is not already taken by
                    another resource. This is
                    If I deploy a page and the domain is currently in an app, it just creates a new page.
                    The domain is removed from the app.
                    <br/>
                    For this to work well we need a short base domain so [appName].[customerName].base.app
                </div>

            </CardComponent>


        </div>
    );
}

export default Startpage;